import { useLocation } from 'react-router-dom';

export const authRoutes = ['/', '/login'];

export default function useUnAuthRoute() {
	const location = useLocation();

	return authRoutes.includes(location?.pathname);
}
